export default __webpack_public_path__ + "static/media/dubbing-gift-background.38d5ecb8.png";